import { AuthService } from 'src/app/services/auth.service';
import { Locality } from './../../../models/locality.model';
import { SelectOptionsService } from './../../../services/select-options.service';
import { OwnersService } from './../../../services/owners.service';
import { getOwnerName, Owner } from './../../../models/owner.model';
import { SelectOption } from './../../../models/select-option.model';
import { ErrorResponse } from './../../../models/error.model';
import { UtilsService } from './../../../services/utils.service';
import { PropertiesService } from './../../../services/properties.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { Property, PropertyType } from './../../../models/property.model';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { CSVColumnMap } from '../../generics/bulk-creator/bulk-creator.component';
import { generateAddressFG } from 'src/app/models/address.model';
import { User } from 'src/app/models/user.model';
import { Broker } from 'src/app/models/broker.model';
import { MatDialog } from '@angular/material/dialog';
import { BrokerSelectorDialogComponent } from 'src/app/dialogs/broker-selector-dialog/broker-selector-dialog.component';

@Component({
    selector: 'app-edit-property',
    templateUrl: './edit-property.component.html',
    styleUrls: ['./edit-property.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EditPropertyComponent implements OnInit {

    getOwnerName = getOwnerName;

    property: Property;
    owners: Owner[][] = [];
    user: User;
    broker: Broker;

    addressSectionFG = generateAddressFG();

    rentalSectionFG = new UntypedFormGroup({
        alquiler: new UntypedFormControl('', [Validators.required]),
        expensas: new UntypedFormControl('', [Validators.required]),
        codigo: new UntypedFormControl('', [Validators.required]),
        tipo: new UntypedFormControl('', [Validators.required]),
        cantidadAmbientes: new UntypedFormControl('', [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]),
        actualizacion: new UntypedFormControl('', []),
        periodoActualizacion: new UntypedFormControl('', []),
        propietarios: new UntypedFormArray([], []),
    });

    propertyTypes: SelectOption[] = [
        { codigo: 'VIVIENDA', descripcion: 'Vivienda' },
        { codigo: 'COMERCIAL', descripcion: 'Comercial' },
        { codigo: 'AMBOS', descripcion: 'Ambos' },
    ];

    updatePeriods: SelectOption[] = [
        { codigo: 3, descripcion: 'Trimestral' },
        { codigo: 6, descripcion: 'Semestral' },
        { codigo: 12, descripcion: 'Anual' },
    ];

    @ViewChild('stepper', { static: true })
    stepper: MatStepper;

    bulkCreatorColumnMaps: CSVColumnMap[] = [
        { key: 'tipoCalle', description: 'Tipo de calle' },
        { key: 'calle', description: 'Calle' },
        { key: 'numero', description: 'Número' },
        { key: 'piso', description: 'Piso' },
        { key: 'departamento', description: 'Departamento' },
        { key: 'codigoPostal', description: 'Código postal' },
        { key: 'provincia', description: 'Provincia' },
        { key: 'municipio', description: 'Municipio' },
        { key: 'localidad', description: 'Localidad' },
        { key: 'alquiler', description: 'Alquiler' },
        { key: 'expensas', description: 'Expensas' },
        { key: 'cantidadAmbientes', description: 'Cantidad de ambientes' },
        { key: 'codigo', description: 'Código' },
        { key: 'tipo', description: 'Tipo de propiedad' },
        { key: 'actualizacion', description: 'Monto de actualización' },
        { key: 'periodoActualizacion', description: 'Periodo de actualización' },
        { key: 'propietarios', description: 'Propietarios' },
    ];

    validatorFormGroup = new UntypedFormGroup({
        tipoCalle: new UntypedFormControl('', [Validators.required]),
        calle: new UntypedFormControl('', [Validators.required]),
        numero: new UntypedFormControl('', [Validators.required]),
        piso: new UntypedFormControl('', []),
        departamento: new UntypedFormControl('', []),
        codigoPostal: new UntypedFormControl('', [Validators.required]),
        provincia: new UntypedFormControl('', []),
        municipio: new UntypedFormControl('', []),
        localidad: new UntypedFormControl('', []),
        alquiler: new UntypedFormControl('', [Validators.required]),
        expensas: new UntypedFormControl('', [Validators.required]),
        cantidadAmbientes: new UntypedFormControl('', [Validators.required]),
        codigo: new UntypedFormControl('', [Validators.required]),
        tipo: new UntypedFormControl('', [Validators.required]),
        actualizacion: new UntypedFormControl('', []),
        periodoActualizacion: new UntypedFormControl('', []),
        propietarios: new UntypedFormControl([], []),
    });

    get ownersArray() {
        return this.rentalSectionFG.get('propietarios') as UntypedFormArray;
    }

    get showBrokerSelectionStep() {
        return this.user?.tipo === 'CORPORATIVO' || this.user.tipo === 'OFICINA';
    }

    constructor(
        private route: ActivatedRoute,
        private propertiesService: PropertiesService,
        private ownersService: OwnersService,
        public utilsService: UtilsService,
        private router: Router,
        private selectOptionsService: SelectOptionsService,
        private authService: AuthService,
        private dialog: MatDialog,
    ) { }

    ngOnInit(): void {

        this.addOwner();

        this.user = this.authService.getUser();
        if (this.user.tipo === 'AGENTE' && this.user.agente) {
            this.broker = this.user.agente;
        }

        this.route.params.subscribe(params => {
            if (params?.id) {
                this.propertiesService.getPropertyById(params.id).subscribe(property => {
                    this.property = property;
                    this.fillFormsWithPropertyData();
                    if (this.property.agente) {
                        this.broker = this.property.agente;
                    }
                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener datos de la propiedad', error.error?.descripcion));
            }
        });
        this.rentalSectionFG.controls.tipo.valueChanges.subscribe((newValue: PropertyType) => {
            this.rentalSectionFG.controls.actualizacion.setValue('');
            this.rentalSectionFG.controls.periodoActualizacion.setValue('');
        });
        this.rentalSectionFG.controls.codigo.valueChanges.subscribe(newValue => {
            this.checkCodigoAvailability(newValue);
        });
    }

    checkCodigoAvailability(codigo: string) {
        if (codigo !== this.property?.codigo) {
            this.propertiesService.isAvailable('codigo', codigo).subscribe(response => {
                let errors: any;
                if (!response.disponible)
                    errors = { notAvailable: true };
                this.rentalSectionFG.controls.codigo.setErrors(errors);
            }, () => {}); // Ignoramos el error
        }
    }

    fillFormsWithPropertyData() {
        this.addressSectionFG.setValue({
            tipoCalle: this.property.direccion.tipoCalle,
            calle: this.property.direccion.calle,
            numero: this.property.direccion.numero,
            piso: this.property.direccion.piso,
            departamento: this.property.direccion.departamento,
            codigoPostal: this.property.direccion.codigoPostal,
            localidad: this.property.direccion.localidad
        });

        this.ownersArray.clear();
        this.property.propietarios.forEach(() => this.addOwner());
        this.rentalSectionFG.setValue({
            alquiler: this.property.alquiler,
            expensas: this.property.expensas,
            codigo: this.property.codigo,
            tipo: this.property.tipo,
            cantidadAmbientes: this.property.cantidadAmbientes,
            propietarios: this.property.propietarios,
            actualizacion: this.property.actualizacion,
            periodoActualizacion: this.property.periodoActualizacion,
        });
    }

    getResultingProperty() {
        return {
            id: this.property?.id,
            idOficina: this.broker?.oficina?.id,
            idAgente: this.broker?.id,
            alquiler: this.rentalSectionFG.value.alquiler,
            expensas: this.rentalSectionFG.value.expensas,
            propietarios: this.rentalSectionFG.value.propietarios.filter(owner => typeof owner !== 'string'),
            tipo: this.rentalSectionFG.value.tipo,
            cantidadAmbientes: this.rentalSectionFG.value.cantidadAmbientes,
            codigo: this.rentalSectionFG.value.codigo,
            actualizacion: this.rentalSectionFG.value.actualizacion,
            periodoActualizacion: this.rentalSectionFG.value.periodoActualizacion,
            direccion: {
                tipoCalle: this.addressSectionFG.value.tipoCalle,
                calle: this.addressSectionFG.value.calle,
                numero: this.addressSectionFG.value.numero,
                piso: this.addressSectionFG.value.piso,
                departamento: this.addressSectionFG.value.departamento,
                codigoPostal: this.addressSectionFG.value.codigoPostal,
                localidad: this.addressSectionFG.value.localidad
            },
            tipoProducto: 'GARANTIA'
        } as Property;
    }

    createProperty() {
        if (!this.addressSectionFG.valid) {
            this.stepper.selectedIndex = this.showBrokerSelectionStep ? 1 : 0;
            return;
        } else if (!this.rentalSectionFG.valid) {
            this.stepper.selectedIndex = this.showBrokerSelectionStep ? 2 : 1;
            return;
        }
        const property = this.getResultingProperty();
        if (this.property) {
            this.propertiesService.editProperty(property).subscribe(_ => {
                this.router.navigate(['propiedades']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al modificar propiedad', error.error?.descripcion));
        } else {
            this.propertiesService.createProperty(property).subscribe(_ => {
                this.router.navigate(['propiedades']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al crear propiedades', error.error?.descripcion));
        }
    }

    addOwner() {
        const control = new UntypedFormControl('', [Validators.required, this.utilsService.autocompleteSelectedValidator]);
        const i = this.ownersArray.length;
        control.valueChanges.subscribe(value => {
            if (typeof value !== 'string') return;
            this.ownersService.searchOwner(value).subscribe(owners => {
                this.owners[i] = owners;
            }, (error: ErrorResponse) => this.utilsService.alert('Error buscando propietarios', error.error?.descripcion));
        });
        this.ownersArray.push(control);
        this.owners.push([]);
    }

    deleteOwner(index: number) {
        this.ownersArray.removeAt(index);
        this.owners.splice(index, 1);
    }

    displayFn(owner: Owner): string {
        return owner ? getOwnerName(owner) : '';
    }

    getBulkCreatorErrors = (row: any) => {
        const errors = [];
        if (row) {
            this.validatorFormGroup.setValue(row);
            Object.keys(this.validatorFormGroup.controls).map(controlName => {
                const control = this.validatorFormGroup.controls[controlName];
                if (!control.valid) {
                    Object.keys(control.errors).forEach(error => {
                        errors.push(`Campo: ${controlName}, error: ${error}.`);
                    });
                }
            });
            if (row.tipo === 'COMERCIAL') {
                if (!row.actualizacion) {
                    errors.push(`Si la propiedad es de tipo comercial debe completar el monto de actualización.`);
                }
                if (!row.periodoActualizacion) {
                    errors.push(`Si la propiedad es de tipo comercial debe completar el perioodo de actualización.`);
                }
            }
            if (row.tipo !== 'COMERCIAL' && row.tipo !== 'VIVIENDA') {
                errors.push(`El tipo de propiedad debe ser "COMERCIAL" o "VIVIENDA".`);
            }
        }
        return errors;
    }

    async getLocality(provinceName: string, municipalityName: string, localityName: string, index: number): Promise<Locality> {
        const provinces = await this.selectOptionsService.getProvinces().toPromise();
        const province = provinces.find(p => p.descripcion === provinceName || p.codigo === provinceName);
        if (province) {
            const municipalities = await this.selectOptionsService.getMunicipalities(province.codigo).toPromise();
            const municipality = municipalities.find(m => m.descripcion === municipalityName || m.codigo === municipalityName);
            if (municipality) {
                const localities = await this.selectOptionsService.getLocalities(province.codigo, municipality.codigo).toPromise();
                const locality = localities.find(l => l.descripcion === localityName || l.codigo === localityName);
                if (locality) {
                    return locality;
                } else {
                    throw new Error('Localidad no encontrada en nuestra base de datos, fila: ' + index + 1);
                }
            } else {
                throw new Error('Municipalidad no encontrada en nuestra base de datos, fila: ' + index + 1);
            }
        } else {
            throw new Error('Provincia no encontrada en nuestra base de datos, fila: ' + index + 1);
        }
    }

    bulkCreatorSubmit = async (values: any[]) => {
        const properties = await Promise.all(values.map(async (row, index) => ({
            alquiler: row.alquiler,
            expensas: row.expensas,
            cantidadAmbientes: row.cantidadAmbientes,
            codigosPropietarios: (row.propietarios as string).split(',').map(cod => cod.trim()),
            tipo: row.tipo,
            codigo: row.codigo,
            actualizacion: row.actualizacion,
            periodoActualizacion: row.periodoActualizacion,
            direccion: {
                tipoCalle: row.tipoCalle,
                calle: row.calle,
                numero: row.numero,
                piso: row.piso,
                departamento: row.departamento,
                codigoPostal: row.codigoPostal,
                localidad: await this.getLocality(row.provincia, row.municipio, row.localidad, index)
            }
        } as Property)));
        return await this.propertiesService.bulkLoad(properties).toPromise();
    }

    openSelectBrokerModal() {
        this.dialog.open(BrokerSelectorDialogComponent).afterClosed().subscribe({
            next: (broker: Broker | undefined) => {
                if (broker) {
                    this.broker = broker;
                    setTimeout(() => {
                        this.stepper?.next();
                    });
                }
            }
        });
    }
}
